import React from 'react';

import { curePropTypes } from '@components/Cure/types';

const HandpickedCure = ({ children }) => (
  <div className="handpicked-cure">
    <img
      className="handpicked-cure__badge"
      src="/images/currate-choice.svg"
      alt="CureRate Choice"
    />
    {children}
  </div>
);

HandpickedCure.propTypes = curePropTypes;

export default HandpickedCure;
